import React from 'react';
import { PublicDialogButton } from './PublicDialog';
import './DialogContractSecurityReview.css';

export default function DialogContractSecurityReview({ onCancel, onContinue }) {
  return (
    <div className="publicDialogContent contractSecurityReview">
      <header className="publicDialogHeader">
        <h2 id="public-dialog-title">Contract security review</h2>
      </header>
      <div className="publicDialogBody">
        <p>We’re reviewing our smart contracts for security vulnerabilities. We recommend waiting until this review is complete before creating or funding an agreement.</p>
        <div className="contractSecurityCompatibility">
          <h3>Wallet compatibility</h3>
          <p>Both parties’ addresses and the arbitrator’s address must be able to receive ETH transfers with a 2,300-gas allowance. Some smart-contract wallets cannot do this. Using an incompatible address can cause payouts to fail and funds to become stuck. Confirm compatibility for all three addresses before proceeding.</p>
        </div>
        <p>Please check back after we’ve completed the review.</p>
        <div className="contractSecurityActions">
          <PublicDialogButton name="cancel" text="Cancel" onClick={onCancel} />
          <PublicDialogButton name="continue_anyway" text="Continue anyway" onClick={onContinue} />
        </div>
      </div>
    </div>
  );
}
